import { render, staticRenderFns } from "./ConfigImg.vue?vue&type=template&id=372ad4be&scoped=true&"
import script from "./ConfigImg.vue?vue&type=script&lang=js&"
export * from "./ConfigImg.vue?vue&type=script&lang=js&"
import style0 from "./ConfigImg.vue?vue&type=style&index=0&id=372ad4be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372ad4be",
  null
  
)

export default component.exports